const linkResolver = (doc) => {
  if (doc.type === 'home') return '/';
  else if (doc.type === 'page') return `/pages/${doc.id}`;
  else if (doc.type === 'page_free') return `/pages/${doc.id}`;
  else if (doc.type === 'about') return '/about';
  else return `/`;
};

export default linkResolver;
